Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles(_ref) {
  var isCentred = _ref.isCentred;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    spacing = _STYLES$useStyles.spacing,
    bp = _STYLES$useStyles.bp,
    fontBold = _STYLES$useStyles.fontBold,
    fontRegular = _STYLES$useStyles.fontRegular,
    boxShadows = _STYLES$useStyles.boxShadows,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight;
  var _largeBp = [bp.mobile_xl, bp.tablet, bp.desktop];
  var _smallBp = [bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m];
  var _xSmallBp = [bp.mobile_xs, bp.mobile_s];
  var _borderRadius = (0, _styles.getREM)(1);
  if (bp.mobile_xs) {
    _borderRadius = (0, _styles.getREM)(0.5);
  }
  var _imageWidth = 80;
  var _imageHeight = 80;
  if (bp.not(_largeBp)) {
    _imageWidth = 70;
    _imageHeight = 70;
  }
  var _paddingVertical = spacing.l;
  var _paddingHorizontal = spacing.normal;
  if (bp.is(_smallBp)) {
    _paddingHorizontal = spacing.s;
  }
  var container = Object.assign({
    width: '100%',
    position: 'relative',
    backgroundColor: COLORS.white,
    borderRadius: _borderRadius,
    paddingLeft: _paddingHorizontal,
    paddingRight: _paddingHorizontal,
    paddingTop: _paddingVertical,
    paddingBottom: _paddingVertical
  }, boxShadows.card.all);
  var container_pointerOver = Object.assign({}, boxShadows.card_pointerOver.all);
  var image = {
    width: _imageWidth,
    height: _imageHeight
  };
  if (bp.is(_largeBp)) {
    image.left = container.paddingLeft;
  }
  if (bp.mobile_l) {
    image.right = container.paddingRight;
  }
  if (bp.not(_smallBp)) {
    image.position = 'absolute';
    image.top = container.paddingTop;
  }
  var container_image = {
    minHeight: _reactNative.Platform.OS === 'web' ? "calc(".concat(_paddingVertical, " * 2 + ").concat(_imageHeight, "px)") : _paddingVertical * 2 + _imageHeight
  };
  if (bp.is(_largeBp)) {
    container_image.paddingLeft = _reactNative.Platform.OS === 'web' ? "calc(".concat(_paddingHorizontal, " * 2 + ").concat(_imageWidth, "px)") : _paddingHorizontal * 2 + _imageWidth;
  }
  if (bp.mobile_l) {
    container_image.paddingRight = _reactNative.Platform.OS === 'web' ? "calc(".concat(_paddingHorizontal, " * 2 + ").concat(_imageWidth, "px)") : _paddingHorizontal * 2 + _imageWidth;
  }
  if (bp.is(_xSmallBp)) {
    container_image.paddingRight = _paddingHorizontal;
    container_image.paddingLeft = _paddingHorizontal;
  }
  var primaryActionContainer = {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  };
  var primaryActionText = {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    borderRadius: _borderRadius
  };
  var contentContainer = {
    flexDirection: 'column',
    zIndex: 2
  };
  if (bp.is(_largeBp)) {
    contentContainer.flexDirection = 'row';
    contentContainer.alignItems = 'center';
    contentContainer.justifyContent = 'space-between';
  }
  var content = {
    flex: 1
  };
  if (isCentred || bp.is(_smallBp)) {
    content.alignItems = 'center';
  }
  var content_button = {
    paddingRight: _paddingHorizontal
  };
  var buttonContainer = {};
  if (bp.not(_largeBp)) {
    buttonContainer.alignSelf = 'flex-start';
    buttonContainer.marginTop = spacing.m;
  }
  if (bp.is(_smallBp)) {
    buttonContainer.alignSelf = 'center';
  }
  var titleContainer = {
    marginBottom: 0
  };
  var title = Object.assign({}, fontBold, {
    color: COLORS.aubergine,
    fontSize: fontSize.m,
    lineHeight: lineHeight.m
  });
  if (isCentred || bp.is(_smallBp)) {
    titleContainer.textAlign = 'center';
    title.textAlign = 'center';
  }
  var descriptionContainer = {
    marginTop: spacing.s,
    marginBottom: 0
  };
  var description = Object.assign({}, fontRegular, {
    color: COLORS.aubergine,
    fontSize: fontSize.normal,
    lineHeight: lineHeight.normal
  });
  if (bp.is(_smallBp)) {
    description.fontSize = fontSize.s;
    description.lineHeight = lineHeight.s;
  }
  if (isCentred || bp.is(_smallBp)) {
    descriptionContainer.textAlign = 'center';
    description.textAlign = 'center';
  }
  var children = {
    zIndex: 2,
    paddingTop: spacing.m,
    marginTop: 'auto'
  };
  var topActions = {
    gap: (0, _styles.getREM)(0.375),
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: spacing.normal
  };
  if (bp.is(_smallBp)) {
    topActions.justifyContent = 'center';
    topActions.alignItems = 'center';
    topActions.flexDirection = 'column';
    topActions.gap = spacing.normal;
  }
  var secondaryActionContainer = {
    zIndex: 2,
    paddingTop: spacing.normal,
    alignItems: 'center'
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    container_pointerOver: container_pointerOver,
    container_image: container_image,
    image: image,
    primaryActionContainer: primaryActionContainer,
    primaryActionText: primaryActionText,
    contentContainer: contentContainer,
    content: content,
    content_button: content_button,
    buttonContainer: buttonContainer,
    titleContainer: titleContainer,
    title: title,
    descriptionContainer: descriptionContainer,
    description: description,
    children: children,
    topActions: topActions,
    secondaryActionContainer: secondaryActionContainer
  });
  return {
    styles: styles
  };
};